module.exports = __webpack_public_path__ + "media/images/checked-thumbnail-active-bef6dc260eab6ed20945410252d7a701.png";